module.exports = __webpack_public_path__ + "static/media/pulverizador.40b62247.svg";